export interface FilterOptions {
  fieldName: string;
  fieldFriendlyName: string;
  operators: FilterOptionsOperators[];
  values: string[];
}

export enum FilterOptionsOperators {
  IN = 'IN',
  NOT_IN = 'NOT IN',
  CONTAINS = 'CONTAINS',
  STARTS_WITH = 'STARTS WITH',
}
